import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { EopSectionService } from './eopSection.service';
import { CustomEopService } from './customEop.service';
import { ICustomEopSection, IEopSection } from '../models/eopSection';

@Injectable({
  providedIn: 'root'
})
export class EopNavigationService {
  private totalPagesSubject = new BehaviorSubject<{ title: string; route: string }[]>([]);
  totalPages$ = this.totalPagesSubject.asObservable();

  private defaultPages = [
    { title: 'EOP Summary', route: 'summary' },
    { title: 'Core Planning Team', route: 'core-planning-team' },
    { title: 'NIMS & ICS', route: 'nims-ics' },
    { title: 'Schedule', route: 'schedule' },
    { title: 'Assessments', route: 'assessments' },
    { title: 'Threats & Hazards', route: 'threats-hazards' },
    { title: 'Functions', route: 'functions' },
    { title: 'Threats & Hazards Objectives', route: 'threats-hazards-objectives' },
    { title: 'Functional Assignments', route: 'functional-assignments' },
    { title: 'Courses of Action for Functions', route: 'functions-courses-of-action' },
    { title: 'Courses of Action for Threats/Hazards', route: 'threats-hazards-courses-of-action' },
    { title: 'Prepare Your EOP', route: 'prepare-your-eop' },
  ];

  constructor(
    private eopSectionService: EopSectionService,
    private customEopService: CustomEopService
  ) {}

  loadTotalPages(buildingId: string): void {
    let buildingPages: { title: string; route: string }[] = [];
    let customPages: { title: string; route: string }[] = [];

    this.eopSectionService.getEopSectionsByBuildingId(buildingId).subscribe({
      next: (eopRes) => {
        buildingPages = eopRes.data.map((section: IEopSection) => ({
          title: section.type,
          route: `basic-plan/${section.route}`
        }));

        this.customEopService.getCustomEopByBuildingId(buildingId).subscribe({
          next: (customRes) => {
            customPages = (customRes.data.sort((a: ICustomEopSection, b: ICustomEopSection) => (a.title ?? '').localeCompare(b.title ?? '')) || []).map((section: ICustomEopSection) => ({
              title: section.title ?? '',
              route: `custom-page/${section.id}`
            }));

            const combined = [...this.defaultPages, ...buildingPages, ...customPages];
            this.totalPagesSubject.next(combined);

            console.log('Total pages loaded:', combined);
          }
        });
      }
    });
  }
}
